(function (global, factory) {
  typeof exports === "object" && typeof module !== "undefined"
    ? factory(exports)
    : typeof define === "function" && define.amd
    ? define(["exports"], factory)
    : factory((global.pell = {}));
})(this, function (exports) {
  "use strict";

  var _extends =
    Object.assign ||
    function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };

  var defaultParagraphSeparatorString = "defaultParagraphSeparator";
  var formatBlock = "formatBlock";
  var addEventListener = function addEventListener(parent, type, listener) {
    return parent.addEventListener(type, listener);
  };
  var appendChild = function appendChild(parent, child) {
    return parent.appendChild(child);
  };
  var createElement = function createElement(tag) {
    return document.createElement(tag);
  };
  var queryCommandState = function queryCommandState(command) {
    return document.queryCommandState(command);
  };
  var queryCommandValue = function queryCommandValue(command) {
    return document.queryCommandValue(command);
  };

  var exec = function exec(command) {
    var value =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return document.execCommand(command, false, value);
  };

  var defaultActions = {
    bold: {
      icon:
        '<svg viewBox="0 0 18 18"> <path class="ei-stroke" d="M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z"></path> <path class="ei-stroke" d="M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z"></path> </svg>',
      title: "Bold",
      state: function state() {
        return queryCommandState("bold");
      },
      result: function result() {
        return exec("bold");
      },
    },
    italic: {
      icon:
        '<svg viewBox="0 0 18 18"> <line class="ei-stroke" x1="7" x2="13" y1="4" y2="4"></line> <line class="ei-stroke" x1="5" x2="11" y1="14" y2="14"></line> <line class="ei-stroke" x1="8" x2="10" y1="14" y2="4"></line> </svg>',
      title: "Italic",
      state: function state() {
        return queryCommandState("italic");
      },
      result: function result() {
        return exec("italic");
      },
    },
    underline: {
      icon:
        '<svg viewBox="0 0 18 18"> <path class="ei-stroke" d="M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3"></path> <rect class="ei-fill" height="1" rx="0.5" ry="0.5" width="12" x="3" y="15"></rect> </svg>',
      title: "Underline",
      state: function state() {
        return queryCommandState("underline");
      },
      result: function result() {
        return exec("underline");
      },
    },
    strikethrough: {
      icon:
        '<svg viewBox="0 0 18 18"> <line class="ei-stroke ei-thin" x1="15.5" x2="2.5" y1="8.5" y2="9.5"></line> <path class="ei-fill" d="M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z"></path> <path class="ei-fill" d="M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z"></path> </svg>',
      title: "Strike-through",
      state: function state() {
        return queryCommandState("strikeThrough");
      },
      result: function result() {
        return exec("strikeThrough");
      },
    },
    heading1: {
      icon: "<b>H<sub>1</sub></b>",
      title: "Heading 1",
      result: function result() {
        return exec(formatBlock, "<h1>");
      },
    },
    heading2: {
      icon: "<b>H<sub>2</sub></b>",
      title: "Heading 2",
      result: function result() {
        return exec(formatBlock, "<h2>");
      },
    },
    paragraph: {
      icon: "&#182;",
      title: "Paragraph",
      result: function result() {
        return exec(formatBlock, "<p>");
      },
    },
    quote: {
      icon:
        '<svg viewBox="0 0 18 18"> <rect class="ei-fill ei-stroke" height="3" width="4" x="3" y="4"></rect> <rect class="ei-fill ei-stroke" height="3" width="4" x="10" y="4"></rect> <path class="ei-even ei-fill ei-stroke" d="M7,8c0,4.031-3,5-4,6"></path> <path class="ei-even ei-fill ei-stroke" d="M14,8c0,4.031-3,5-4,6"></path> </svg>',
      title: "Quote",
      result: function result() {
        return exec(formatBlock, "<blockquote>");
      },
    },
    olist: {
      icon:
        '<svg viewBox="0 0 18 18"> <line class="ei-stroke" x1="7" x2="15" y1="4" y2="4"></line> <line class="ei-stroke" x1="7" x2="15" y1="9" y2="9"></line> <line class="ei-stroke" x1="7" x2="15" y1="14" y2="14"></line> <line class="ei-stroke ql-thin" x1="2.5" x2="4.5" y1="5.5" y2="5.5"></line> <path class="ei-fill" d="M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z"></path> <path class="ei-stroke ei-thin" d="M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156"></path> <path class="ei-stroke ei-thin" d="M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109"></path> </svg>',
      title: "Ordered List",
      result: function result() {
        return exec("insertOrderedList");
      },
    },
    ulist: {
      icon:
        '<svg viewBox="0 0 18 18"> <line class="ei-stroke" x1="6" x2="15" y1="4" y2="4"></line> <line class="ei-stroke" x1="6" x2="15" y1="9" y2="9"></line> <line class="ei-stroke" x1="6" x2="15" y1="14" y2="14"></line> <line class="ei-stroke" x1="3" x2="3" y1="4" y2="4"></line> <line class="ei-stroke" x1="3" x2="3" y1="9" y2="9"></line> <line class="ei-stroke" x1="3" x2="3" y1="14" y2="14"></line> </svg>',
      title: "Unordered List",
      result: function result() {
        return exec("insertUnorderedList");
      },
    },
    code: {
      icon:
        '<svg viewBox="0 0 18 18"> <polyline class="ei-even ei-stroke" points="5 5 1 9 5 13"></polyline> <polyline class="ei-even ei-stroke" points="13 5 17 9 13 13"></polyline> <line class="ei-stroke" x1="10" x2="8" y1="3" y2="15"></line> </svg>',
      title: "Code",
      result: function result() {
        return exec(formatBlock, "<pre>");
      },
    },
    line: {
      icon: "&#8213;",
      title: "Horizontal Line",
      result: function result() {
        return exec("insertHorizontalRule");
      },
    },
    link: {
      icon:
        '<svg viewBox="0 0 18 18"> <line class="ei-stroke" x1="7" x2="11" y1="7" y2="11"></line> <path class="ei-even ei-stroke" d="M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z"></path> <path class="ei-even ei-stroke" d="M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z"></path> </svg>',
      title: "Link",
      result: function result() {
        var url = window.prompt("Enter the link URL");
        if (url) exec("createLink", url);
      },
    },
    image: {
      icon:
        '<svg viewBox="0 0 18 18"> <rect class="ei-stroke" height="10" width="12" x="3" y="4"></rect> <circle class="ei-fill" cx="6" cy="7" r="1"></circle> <polyline class="ei-even ql-fill" points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"></polyline> </svg>',
      title: "Image",
      result: function result() {
        var url = window.prompt("Enter the image URL");
        if (url) exec("insertImage", url);
      },
    },
  };

  var defaultClasses = {
    actionbar: "pell-actionbar",
    button: "pell-button",
    content: "pell-content",
    selected: "pell-button-selected",
  };

  var init = function init(settings) {
    var actions = settings.actions
      ? settings.actions.map(function (action) {
          if (typeof action === "string") return defaultActions[action];
          else if (defaultActions[action.name])
            return _extends({}, defaultActions[action.name], action);
          return action;
        })
      : Object.keys(defaultActions).map(function (action) {
          return defaultActions[action];
        });

    var classes = _extends({}, defaultClasses, settings.classes);

    var defaultParagraphSeparator =
      settings[defaultParagraphSeparatorString] || "div";

    var actionbar = createElement("div");
    actionbar.className = classes.actionbar;
    appendChild(settings.element, actionbar);

    var content = (settings.element.content = createElement("div"));
    content.contentEditable = true;
    content.className = classes.content;
    if (settings.placeholder) {
      content.dataset.placeholder = settings.placeholder;
    }
    content.oninput = function (_ref) {
      var firstChild = _ref.target.firstChild;

      if (firstChild && firstChild.nodeType === 3)
        exec(formatBlock, "<" + defaultParagraphSeparator + ">");
      else if (content.innerHTML === "<br>") content.innerHTML = "";
      settings.onChange(content.innerHTML);
    };
    content.onkeydown = function (event) {
      if (
        event.key === "Enter" &&
        queryCommandValue(formatBlock) === "blockquote"
      ) {
        setTimeout(function () {
          return exec(formatBlock, "<" + defaultParagraphSeparator + ">");
        }, 0);
      }
    };
    appendChild(settings.element, content);

    actions.forEach(function (action) {
      var button = createElement("button");
      button.className = classes.button;
      button.innerHTML = action.icon;
      button.title = action.title;
      button.setAttribute("type", "button");
      button.onClick = function () {
        return action.result() && content.focus();
      };

      if (action.state) {
        var handler = function handler() {
          return button.classList[action.state() ? "add" : "remove"](
            classes.selected
          );
        };
        addEventListener(content, "keyup", handler);
        addEventListener(content, "mouseup", handler);
        addEventListener(button, "click", handler);
      }

      appendChild(actionbar, button);
    });

    if (settings.styleWithCSS) exec("styleWithCSS");
    exec(defaultParagraphSeparatorString, defaultParagraphSeparator);

    return settings.element;
  };

  var pell = { exec: exec, init: init };

  exports.exec = exec;
  exports.init = init;
  exports["default"] = pell;

  Object.defineProperty(exports, "__esModule", { value: true });
});
